
import { paginationMixin } from "@/mixins/paginationMixin";
import { _ } from "vue-underscore";
import Datepicker from 'vuejs-datepicker';
export default {
	data: () => ({
		selectedEvaluator:{},
		evaluator:{},
		comments:"",
		evaluators: [],
		evaluatorList:[],
		statesList:[],
		evaluations:[],
		tableData:[],
		error: "",
		searchText: "",
		showLoader: false,
		fromDate : new Date(),
		toDate : new Date(),
		sortBy:"",
		sortDirection:'asc'

	}),
	components: {
		Datepicker
	},
	mixins: [paginationMixin],
	computed: {
		selectedStudent() {
			return this.evaluations.filter(element => element.isSelected==true);
		}
	},
	methods: {
		applySort(sortBy){
			this.tableData = _.sortBy(this.tableData, function(column) { return column[sortBy]; });
			if(this.sortBy == sortBy && this.sortDirection=='asc'){
				this.sortDirection='desc';
				this.tableData = this.tableData.reverse();
			}else{
				this.sortDirection='asc';
			}
			this.sortBy = sortBy;
		},


		resetForm() {
			this.$refs.observer.reset();
			this.evaluator = {
				id: 0,
			};
		},
		convertDate(value){
			const date = new Date(value);
			return date.getFullYear() + "-" + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) +"-"+ (date.getDate() > 9 ? '' : '0') + date.getDate();
		},
		changeEvaluator(){
			this.evaluator = this.evaluatorList.find(element=> element.id == this.selectedEvaluator)
			this.evaluator.status=this.evaluator.status_id;
			this.getOpenEvaluations();
			console.log('inside changeEvaluator: ',this.evaluator.id);
		},

		getAllEvaluators() {
			let _vm = this;
			_vm.showLoader = true;
			console.log('inside getAllEvaluators: ',_vm.evaluator);
			this.axios
				.get("/get_evaluators.php")
				.then(function(response) {
					_vm.showLoader = false;
					_vm.evaluatorList = response.data.data;
					_vm.selectedEvaluator = _vm.evaluatorList[0];
					_vm.changeEvaluator();

				})
				.catch(function(error) {
					console.log(error);
				});
		},
		getOpenEvaluations() {
			let _vm = this;
			_vm.showLoader = true;
			this.axios
				.get("/get_report_assigned_cases_by_evaluator.php?from_date="+this.convertDate(this.fromDate)+"&to_date="+ this.convertDate(this.toDate)+"&evaluator_id="+this.evaluator.id)
				.then(function(response) {
					_vm.showLoader = false;
					_vm.evaluations = response.data.data;
					_vm.tableData = response.data.data;
				})
				.catch(function(error) {
					console.log(error);
				});
		},

	},
	mounted() {
		this.getAllEvaluators();
		this.getOpenEvaluations();
	}
};
